(() => {
  // node_modules/ftdomdelegate/main.js
  function Delegate(root) {
    this.listenerMap = [{}, {}];
    if (root) {
      this.root(root);
    }
    this.handle = Delegate.prototype.handle.bind(this);
    this._removedListeners = [];
  }
  Delegate.prototype.root = function (root) {
    const listenerMap = this.listenerMap;
    let eventType;
    if (this.rootElement) {
      for (eventType in listenerMap[1]) {
        if (listenerMap[1].hasOwnProperty(eventType)) {
          this.rootElement.removeEventListener(eventType, this.handle, true);
        }
      }
      for (eventType in listenerMap[0]) {
        if (listenerMap[0].hasOwnProperty(eventType)) {
          this.rootElement.removeEventListener(eventType, this.handle, false);
        }
      }
    }
    if (!root || !root.addEventListener) {
      if (this.rootElement) {
        delete this.rootElement;
      }
      return this;
    }
    this.rootElement = root;
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.addEventListener(eventType, this.handle, true);
      }
    }
    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.addEventListener(eventType, this.handle, false);
      }
    }
    return this;
  };
  Delegate.prototype.captureForType = function (eventType) {
    return ['blur', 'error', 'focus', 'load', 'resize', 'scroll'].indexOf(eventType) !== -1;
  };
  Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
    let root;
    let listenerMap;
    let matcher;
    let matcherParam;
    if (!eventType) {
      throw new TypeError('Invalid event type: ' + eventType);
    }
    if (typeof selector === 'function') {
      useCapture = handler;
      handler = selector;
      selector = null;
    }
    if (useCapture === void 0) {
      useCapture = this.captureForType(eventType);
    }
    if (typeof handler !== 'function') {
      throw new TypeError('Handler must be a type of Function');
    }
    root = this.rootElement;
    listenerMap = this.listenerMap[useCapture ? 1 : 0];
    if (!listenerMap[eventType]) {
      if (root) {
        root.addEventListener(eventType, this.handle, useCapture);
      }
      listenerMap[eventType] = [];
    }
    if (!selector) {
      matcherParam = null;
      matcher = matchesRoot.bind(this);
    } else if (/^[a-z]+$/i.test(selector)) {
      matcherParam = selector;
      matcher = matchesTag;
    } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
      matcherParam = selector.slice(1);
      matcher = matchesId;
    } else {
      matcherParam = selector;
      matcher = Element.prototype.matches;
    }
    listenerMap[eventType].push({
      selector,
      handler,
      matcher,
      matcherParam,
    });
    return this;
  };
  Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
    let i;
    let listener;
    let listenerMap;
    let listenerList;
    let singleEventType;
    if (typeof selector === 'function') {
      useCapture = handler;
      handler = selector;
      selector = null;
    }
    if (useCapture === void 0) {
      this.off(eventType, selector, handler, true);
      this.off(eventType, selector, handler, false);
      return this;
    }
    listenerMap = this.listenerMap[useCapture ? 1 : 0];
    if (!eventType) {
      for (singleEventType in listenerMap) {
        if (listenerMap.hasOwnProperty(singleEventType)) {
          this.off(singleEventType, selector, handler);
        }
      }
      return this;
    }
    listenerList = listenerMap[eventType];
    if (!listenerList || !listenerList.length) {
      return this;
    }
    for (i = listenerList.length - 1; i >= 0; i--) {
      listener = listenerList[i];
      if ((!selector || selector === listener.selector) && (!handler || handler === listener.handler)) {
        this._removedListeners.push(listener);
        listenerList.splice(i, 1);
      }
    }
    if (!listenerList.length) {
      delete listenerMap[eventType];
      if (this.rootElement) {
        this.rootElement.removeEventListener(eventType, this.handle, useCapture);
      }
    }
    return this;
  };
  Delegate.prototype.handle = function (event) {
    let i;
    let l;
    const type = event.type;
    let root;
    let phase;
    let listener;
    let returned;
    let listenerList = [];
    let target;
    const eventIgnore = 'ftLabsDelegateIgnore';
    if (event[eventIgnore] === true) {
      return;
    }
    target = event.target;
    if (target.nodeType === 3) {
      target = target.parentNode;
    }
    if (target.correspondingUseElement) {
      target = target.correspondingUseElement;
    }
    root = this.rootElement;
    phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);
    switch (phase) {
      case 1:
        listenerList = this.listenerMap[1][type];
        break;
      case 2:
        if (this.listenerMap[0] && this.listenerMap[0][type]) {
          listenerList = listenerList.concat(this.listenerMap[0][type]);
        }
        if (this.listenerMap[1] && this.listenerMap[1][type]) {
          listenerList = listenerList.concat(this.listenerMap[1][type]);
        }
        break;
      case 3:
        listenerList = this.listenerMap[0][type];
        break;
    }
    let toFire = [];
    l = listenerList.length;
    while (target && l) {
      for (i = 0; i < l; i++) {
        listener = listenerList[i];
        if (!listener) {
          break;
        }
        if (
          target.tagName &&
          ['button', 'input', 'select', 'textarea'].indexOf(target.tagName.toLowerCase()) > -1 &&
          target.hasAttribute('disabled')
        ) {
          toFire = [];
        } else if (listener.matcher.call(target, listener.matcherParam, target)) {
          toFire.push([event, target, listener]);
        }
      }
      if (target === root) {
        break;
      }
      l = listenerList.length;
      target = target.parentElement || target.parentNode;
      if (target instanceof HTMLDocument) {
        break;
      }
    }
    let ret;
    for (i = 0; i < toFire.length; i++) {
      if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
        continue;
      }
      returned = this.fire.apply(this, toFire[i]);
      if (returned === false) {
        toFire[i][0][eventIgnore] = true;
        toFire[i][0].preventDefault();
        ret = false;
        break;
      }
    }
    return ret;
  };
  Delegate.prototype.fire = function (event, target, listener) {
    return listener.handler.call(target, event, target);
  };
  const main_delegate = Delegate;
  function matchesTag(tagName, element) {
    return tagName.toLowerCase() === element.tagName.toLowerCase();
  }
  function matchesRoot(selector, element) {
    if (this.rootElement === window) {
      return element === document || element === document.documentElement || element === window;
    }
    return this.rootElement === element;
  }
  function matchesId(id, element) {
    return id === element.id;
  }
  Delegate.prototype.destroy = function () {
    this.off();
    this.root();
  };

  function triggerEvent(element, name, data = {}) {
    element.dispatchEvent(
      new CustomEvent(name, {
        bubbles: true,
        detail: data,
      }),
    );
  }

  function throttle(callback, delay3 = 15) {
    let throttleTimeout = null,
      storedEvent = null;
    const throttledEventHandler = (event) => {
      storedEvent = event;
      const shouldHandleEvent = !throttleTimeout;
      if (shouldHandleEvent) {
        callback(storedEvent);
        storedEvent = null;
        throttleTimeout = setTimeout(() => {
          throttleTimeout = null;
          if (storedEvent) {
            throttledEventHandler(storedEvent);
          }
        }, delay3);
      }
    };
    return throttledEventHandler;
  }

  function getSiblings(element, filter, includeSelf = false) {
    let siblings = [];
    let currentElement = element;
    while ((currentElement = currentElement.previousElementSibling)) {
      if (!filter || currentElement.matches(filter)) {
        siblings.push(currentElement);
      }
    }
    if (includeSelf) {
      siblings.push(element);
    }
    currentElement = element;
    while ((currentElement = currentElement.nextElementSibling)) {
      if (!filter || currentElement.matches(filter)) {
        siblings.push(currentElement);
      }
    }
    return siblings;
  }

  var CustomHTMLElement = class extends HTMLElement {
    constructor() {
      super();
      this._hasSectionReloaded = false;
      if (Shopify.designMode) {
        this.rootDelegate.on('shopify:section:select', (event) => {
          const parentSection = this.closest('.shopify-section');
          if (event.target === parentSection && event.detail.load) {
            this._hasSectionReloaded = true;
          }
        });
      }
    }
    get rootDelegate() {
      return (this._rootDelegate = this._rootDelegate || new main_delegate(document.documentElement));
    }
    get delegate() {
      return (this._delegate = this._delegate || new main_delegate(this));
    }
    untilVisible(intersectionObserverOptions = { rootMargin: '30px 0px', threshold: 0 }) {
      const onBecameVisible = () => {
        this.classList.add('became-visible');
        this.style.opacity = '1';
      };
      return new Promise((resolve) => {
        if (window.IntersectionObserver) {
          this.intersectionObserver = new IntersectionObserver((event) => {
            if (event[0].isIntersecting) {
              this.intersectionObserver.disconnect();
              requestAnimationFrame(() => {
                resolve();
                onBecameVisible();
              });
            }
          }, intersectionObserverOptions);
          this.intersectionObserver.observe(this);
        } else {
          resolve();
          onBecameVisible();
        }
      });
    }
    disconnectedCallback() {
      this.delegate.destroy();
      this.rootDelegate.destroy();
      delete this._delegate;
      delete this._rootDelegate;
    }
  };

  var NativeVideo = class extends HTMLElement {
    constructor() {
      super();
      this.hasLoaded = false;
      if (this.autoPlay) {
        this.play();
      } else {
        this.addEventListener('click', this.play.bind(this), { once: true });
      }
    }
    get autoPlay() {
      return this.hasAttribute('autoplay');
    }
    play() {
      if (!this.hasLoaded) {
        this._replaceContent();
      }
      this.querySelector('video').play();
    }
    pause() {
      if (this.hasLoaded) {
        this.querySelector('video').pause();
      }
    }
    _replaceContent() {
      const node = this.querySelector('template').content.firstElementChild.cloneNode(true);
      this.innerHTML = '';
      this.appendChild(node);
      this.firstElementChild.addEventListener('play', () => {
        this.dispatchEvent(new CustomEvent('video:played', { bubbles: true }));
      });
      this.firstElementChild.addEventListener('pause', () => {
        this.dispatchEvent(new CustomEvent('video:paused', { bubbles: true }));
      });
      this.hasLoaded = true;
    }
  };
  window.customElements.define('native-video', NativeVideo);

  var template = `
    <style>
        :host {
        display: inline-block;
        contain: layout;
        position: relative;
        }

        :host([hidden]) {
        display: none;
        }

        s {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        pointer-events: none;
        z-index: 1;
        background-image:
            var(--scroll-shadow-top, radial-gradient(farthest-side at 50% 0%, rgba(0,0,0,.2), rgba(0,0,0,0))),
            var(--scroll-shadow-bottom, radial-gradient(farthest-side at 50% 100%, rgba(0,0,0,.2), rgba(0,0,0,0))),
            var(--scroll-shadow-left, radial-gradient(farthest-side at 0%, rgba(0,0,0,.2), rgba(0,0,0,0))),
            var(--scroll-shadow-right, radial-gradient(farthest-side at 100%, rgba(0,0,0,.2), rgba(0,0,0,0)));
        background-position: top, bottom, left, right;
        background-repeat: no-repeat;
        background-size: 100% var(--top, 0), 100% var(--bottom, 0), var(--left, 0) 100%, var(--right, 0) 100%;
        }
    </style>
    <slot></slot>
    <s></s>
    `;
  var Updater = class {
    constructor(targetElement) {
      this.scheduleUpdate = throttle(() => this.update(targetElement, getComputedStyle(targetElement)));
      this.resizeObserver = new ResizeObserver(this.scheduleUpdate.bind(this));
    }
    start(element) {
      if (this.element) {
        this.stop();
      }
      if (element) {
        element.addEventListener('scroll', this.scheduleUpdate);
        this.resizeObserver.observe(element);
        this.element = element;
      }
    }
    stop() {
      if (!this.element) {
        return;
      }
      this.element.removeEventListener('scroll', this.scheduleUpdate);
      this.resizeObserver.unobserve(this.element);
      this.element = null;
    }
    update(targetElement, style) {
      if (!this.element) {
        return;
      }
      const maxSize = style.getPropertyValue('--scroll-shadow-size')
        ? parseInt(style.getPropertyValue('--scroll-shadow-size'))
        : 0;
      const scroll = {
        top: Math.max(this.element.scrollTop, 0),
        bottom: Math.max(this.element.scrollHeight - this.element.offsetHeight - this.element.scrollTop, 0),
        left: Math.max(this.element.scrollLeft, 0),
        right: Math.max(this.element.scrollWidth - this.element.offsetWidth - this.element.scrollLeft, 0),
      };
      requestAnimationFrame(() => {
        for (const position of ['top', 'bottom', 'left', 'right']) {
          targetElement.style.setProperty(
            `--${position}`,
            `${scroll[position] > maxSize ? maxSize : scroll[position]}px`,
          );
        }
      });
    }
  };
  var ScrollShadow = class extends HTMLElement {
    constructor() {
      super();
      this.attachShadow({ mode: 'open' }).innerHTML = template;
      this.updater = new Updater(this.shadowRoot.lastElementChild);
    }
    connectedCallback() {
      this.shadowRoot.querySelector('slot').addEventListener('slotchange', () => this.start());
      this.start();
    }
    disconnectedCallback() {
      this.updater.stop();
    }
    start() {
      this.updater.start(this.firstElementChild);
    }
  };
  if ('ResizeObserver' in window) {
    window.customElements.define('scroll-shadow', ScrollShadow);
  }

  class ProductMediaImages extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.initSwiper();
      this.addEventListener('swiperControl:select', (event) => this.select(event.detail.index));
    }

    select(idx) {
      this.swiper.slideToLoop(idx);
    }
    initSwiper() {
      const swiperEl = this.querySelector('.swiper');
      const _this = this;
      if (!swiperEl) return;
      const lastIdx = this.dataset.lastIdx;
      this.swiper = new Swiper(swiperEl, {
        observer: true,
        observeParents: true,
        fadeEffect: {
          crossFade: true,
        },
        touchStartPreventDefault: true,
        passiveListeners: false,
        slidesPerView: 1,
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          clickable: true,
        },
        on: {
          init(swiperInstance) {
            const realIndex = swiperInstance.realIndex;
            triggerEvent(_this, 'swiper:ready', {
              realIndex,
            });
          },
          slideChange(swiperInstance) {
            const realIndex = swiperInstance.realIndex;
            triggerEvent(_this, 'swiper:slide-changed', {
              realIndex,
            });
          },
        },
        navigation: {
          nextEl: this.querySelector('.btn-next'),
          prevEl: this.querySelector('.btn-prev'),
        },
      });
      if (lastIdx) {
        this.swiper.slideToLoop(lastIdx);
      }
    }
  }
  if (!customElements.get('product-media-images')) {
    customElements.define('product-media-images', ProductMediaImages);
  }

  var ProductMediaControls = class extends CustomHTMLElement {
    async connectedCallback() {
      this.productMediaImages.addEventListener('swiper:ready', this._onSlideChanged.bind(this, false));
      this.productMediaImages.addEventListener('swiper:slide-changed', this._onSlideChanged.bind(this, true));
      this.delegate.on('click', '[data-action="select"]', (event, target) => {
        this.productMediaImages.select(target.dataset.idx);
      });
    }
    get productMediaImages() {
      return (this._productMediaImages =
        this._productMediaImages || document.getElementById(this.getAttribute('controls')));
    }
    async _onSlideChanged(animate = true, event) {
      const realIndex = event.detail.realIndex || 0;
      const activeItem = this.querySelector(`.product__thumbnail-item[data-idx="${realIndex}"]`);
      activeItem.setAttribute('aria-current', 'true');
      getSiblings(activeItem).forEach((sibling) => sibling.removeAttribute('aria-current'));
      requestAnimationFrame(() => {
        if (activeItem.offsetParent && activeItem.offsetParent !== this) {
          const windowHalfHeight = activeItem.offsetParent.clientHeight / 2,
            windowHalfWidth = activeItem.offsetParent.clientWidth / 2;
          activeItem.offsetParent.scrollTo({
            behavior: animate ? 'smooth' : 'auto',
            top: activeItem.offsetTop - windowHalfHeight + activeItem.clientHeight / 2,
            left: activeItem.offsetLeft - windowHalfWidth + activeItem.clientWidth / 2,
          });
        }
      });
    }
  };
  window.customElements.define('product-media-controls', ProductMediaControls);

  if (!customElements.get('variant-select')) {
    customElements.define(
      'variant-select',
      class VariantSelect extends HTMLElement {
        constructor() {
          super();
          this.rows = this.querySelectorAll('.variant-row');
          this.sectionId = this.dataset.section;
          this.baseUrl = this.dataset.url;
          this.saveText = 'Save';

          const btnId = this.getAttribute('aria-controls');
          this.externalButton = document.getElementById(btnId);
          this.checkoutButton = document.getElementById(`ProductCheckoutButton-${this.sectionId}`);
          this.errorMessageWrapper = this.querySelector('.variants-form__error-message-wrapper');

          this.priceContainer = document.querySelector(`.product-price-${this.sectionId}`);
          if (this.priceContainer) {
            const saveLabel = this.priceContainer.querySelector('.save-label');
            if (saveLabel) {
              this.saveText = saveLabel.innerText.replace(/[0-9.,$€£¥]/g, '').trim();
            }
          }

          this.updateQuantity = this.updateQuantity.bind(this);
          this.addToCart = this.addToCart.bind(this);
          this.handleCheckout = this.handleCheckout.bind(this);
          this.handleErrorMessage = this.handleErrorMessage.bind(this);
          this.updateTotalPrice = this.updateTotalPrice.bind(this);
          this.syncSellableRows = this.syncSellableRows.bind(this);
          this.isRowSellable = this.isRowSellable.bind(this);
          this.getSelectedItems = this.getSelectedItems.bind(this);

          this.abortController = null;
        }

        connectedCallback() {
          // 同步 Liquid 输出的可售状态：无库存但 inventory_policy=continue 的变体，前端不再当作 Sold out。
          this.syncSellableRows();

          this.rows.forEach((row) => {
            const input = row.querySelector('.qty-input');
            const minus = row.querySelector('.minus');
            const plus = row.querySelector('.plus');

            if (minus)
              minus.addEventListener('click', (e) => {
                e.stopPropagation();
                this.updateQuantity(row, input, -1);
              });
            if (plus)
              plus.addEventListener('click', (e) => {
                e.stopPropagation();
                this.updateQuantity(row, input, 1);
              });

            if (input) {
              input.addEventListener('change', () => this.updateQuantity(row, input, 0));
              input.addEventListener('click', (e) => e.stopPropagation());
            }
          });

          if (this.externalButton) {
            this.externalButton.addEventListener('click', this.addToCart);
          }

          if (this.checkoutButton) {
            this.checkoutButton.addEventListener('click', this.handleCheckout);
          }

          this.updateTotalPrice();
        }

        disconnectedCallback() {
          if (this.abortController) this.abortController.abort();
          if (this.externalButton) this.externalButton.removeEventListener('click', this.addToCart);
          if (this.checkoutButton) this.checkoutButton.removeEventListener('click', this.handleCheckout);
        }

        isRowSellable(row) {
          if (!row) return false;

          // main-product-new.liquid 会输出：
          // data-can-sell="true/false"
          // data-inventory-policy="continue/deny"
          const canSell = String(row.dataset.canSell || '').toLowerCase();
          const inventoryPolicy = String(row.dataset.inventoryPolicy || '').toLowerCase();
          const available = String(row.dataset.available || '').toLowerCase();

          if (canSell === 'true' || inventoryPolicy === 'continue' || available === 'true') return true;
          if (canSell === 'false') return false;

          // 老模板没有 data-can-sell 时，兼容原来的 aria-disabled 逻辑。
          return !row.hasAttribute('aria-disabled');
        }

        syncSellableRows() {
          let hasSellableRow = false;

          this.rows.forEach((row) => {
            const input = row.querySelector('.qty-input');
            const minus = row.querySelector('.minus');
            const plus = row.querySelector('.plus');
            const soldOutText = row.querySelector('.variant-sold-out-text');
            const sellable = this.isRowSellable(row);

            if (sellable) {
              hasSellableRow = true;
              row.removeAttribute('aria-disabled');
              if (input) input.disabled = false;
              if (minus) minus.disabled = false;
              if (plus) plus.disabled = false;
              if (soldOutText) soldOutText.style.display = 'none';
            } else {
              row.setAttribute('aria-disabled', 'true');
              if (input) {
                input.value = 0;
                input.disabled = true;
              }
              if (minus) minus.disabled = true;
              if (plus) plus.disabled = true;
              if (soldOutText) soldOutText.style.display = '';
            }
          });

          // 只要存在一个可售变体，就保持 Add To Cart / Buy It Now 可点击。
          // 这样可以兼容 “0 库存 + Continue selling when out of stock”。
          if (hasSellableRow) {
            if (this.externalButton) {
              this.externalButton.disabled = false;
              this.externalButton.removeAttribute('aria-disabled');
              const span = this.externalButton.querySelector('span');
              if (span && /sold out|unavailable/i.test(span.innerText)) span.innerText = 'Add To Cart';
            }
            if (this.checkoutButton) {
              this.checkoutButton.disabled = false;
              this.checkoutButton.removeAttribute('aria-disabled');
            }
          }
        }

        getSelectedItems() {
          const items = [];

          this.rows.forEach((row) => {
            const input = row.querySelector('.qty-input');
            if (!input || input.disabled) return;
            if (!this.isRowSellable(row)) return;

            const qty = parseInt(input.value, 10);
            const variantId = row.dataset.variantId;

            if (qty > 0 && variantId) {
              items.push({ id: parseInt(variantId, 10), quantity: qty });
            }
          });

          return items;
        }

        updateTotalPrice() {
          if (!this.priceContainer) return;

          let totalPrice = 0;
          let totalComparePrice = 0;

          this.rows.forEach((row) => {
            const input = row.querySelector('.qty-input');
            const qty = parseInt(input.value) || 0;

            const price = parseFloat(row.dataset.price) || 0;
            const comparePrice = parseFloat(row.dataset.comparePrice) || price;

            totalPrice += price * qty;
            totalComparePrice += comparePrice * qty;
          });

          let html = '';

          if (totalComparePrice > totalPrice) {
            html += `<span class="price fz-28 fz-m-24 fw-600 fw-m-500">${formatMoneyAmount(totalPrice)}</span>`;
            html += `<s class="compare-price fz-16 fz-m-14">${formatMoneyAmount(totalComparePrice)}</s>`;
            html += `<span class="py-8 px-12 py-m-4 px-m-8 fz-14 fz-m-12 save-label fw-500">${this.saveText} ${formatMoneyAmount(totalComparePrice - totalPrice)}</span>`;
          } else {
            html += `<span class="price fz-28 fz-m-24 fw-600">${formatMoneyAmount(totalPrice)}</span>`;
          }

          this.priceContainer.innerHTML = html;
        }

        updateQuantity(row, input, change) {
          const currentVal = parseInt(input.value) || 0;
          const minQty = parseInt(this.dataset.minQty) || 1;
          // 如果是减少操作
          if (change < 0) {
            // 计算当前所有变体的总数量
            let totalQty = 0;
            this.rows.forEach((r) => {
              const i = r.querySelector('.qty-input');
              totalQty += parseInt(i.value) || 0;
            });

            // 如果总数小于等于 1，且当前行有值（防止减到 0），或者总数即将变为 0，则拦截
            // if (totalQty <= 1 && currentVal > 0) return;
            if (totalQty <= minQty && currentVal > 0) return;
          }

          let val = currentVal + change;
          if (minQty > 1) {
            // 如果当前值在 1 到 起订量之间
            if (val > 0 && val < minQty) {
              // 加号跳到 minQty，减号跳到 0
              val = change > 0 ? minQty : 0;
            }
          }

          // 兜底逻辑：单个 input 不能小于 0
          if (isNaN(val) || val < 0) val = 0;

          // 如果是直接在 input 里输入且输入了 0，我们需要再次检查总数
          // 这一步是为了防止用户手动把 1 改成 0 导致总汇总为 0
          if (change === 0 && val === 0) {
            let otherTotalQty = 0;
            this.rows.forEach((r) => {
              if (r !== row) {
                const i = r.querySelector('.qty-input');
                otherTotalQty += parseInt(i.value) || 0;
              }
            });
            // if (otherTotalQty === 0) val = 1; // 强制变回 1，保证汇总不为 0
            if (otherTotalQty === 0) val = minQty;
          }

          input.value = val;
          this.updateTotalPrice();
        }
        handleErrorMessage(errorMessage = false) {
          if (!this.errorMessageWrapper) return;
          this.errorMessage =
            this.errorMessage || this.errorMessageWrapper.querySelector('.variants-form__error-message');

          this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
          if (errorMessage) {
            this.errorMessage.textContent = errorMessage;
          }
        }

        addToCart(e) {
          if (e) e.preventDefault();
          if (this.externalButton && this.externalButton.disabled) return;

          this.handleErrorMessage();

          this.syncSellableRows();
          const items = this.getSelectedItems();

          if (items.length === 0) {
            this.handleErrorMessage('Please select at least one item.');
            return;
          }

          if (!this.cartDrawer) this.cartDrawer = document.querySelector('cart-drawer');

          let originalText = '';
          let btnTextSpan = null;

          if (this.externalButton) {
            this.externalButton.classList.add('loading');
            this.externalButton.disabled = true;
            this.externalButton.setAttribute('aria-disabled', true);

            btnTextSpan = this.externalButton.querySelector('span');
            if (btnTextSpan) {
              originalText = btnTextSpan.innerText;
              btnTextSpan.innerText = 'Adding...';
            } else {
              originalText = this.externalButton.innerText;
              this.externalButton.innerText = 'Adding...';
            }
          }

          let sectionsToRender = [];
          if (this.cartDrawer) {
            sectionsToRender = this.cartDrawer.getSectionsToRender().map((section) => section.id);
          }
          const bubble = document.getElementById('cart-icon-bubble');
          if (bubble) sectionsToRender.push('cart-icon-bubble');

          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({
              items: items,
              sections: sectionsToRender,
              sections_url: window.location.pathname,
            }),
          })
            .then((response) => response.json())
            .then((data) => {
              if (data.status) {
                let message = data.description || data.message;

                // 注意：如果这里仍然返回 already sold out，说明 Shopify 后端没有允许这个变体售卖。
                // 前端 JS 不能绕过 Shopify 后端库存校验，需要检查该 variant 的 Continue selling 设置、销售渠道/市场/库存地点。
                this.handleErrorMessage(message);
                if (this.cartDrawer) this.cartDrawer.reload();
              } else {
                if (this.cartDrawer) this.cartDrawer.renderContents(data);

                if (data.sections && data.sections['cart-icon-bubble']) {
                  const bubble = document.getElementById('cart-icon-bubble');
                  if (bubble) bubble.innerHTML = data.sections['cart-icon-bubble'];
                }
              }
            })
            .catch((e) => {
              console.error(e);
              this.handleErrorMessage('Something went wrong. Please try again.');
            })
            .finally(() => {
              if (this.cartDrawer && this.cartDrawer.classList.contains('is-empty')) {
                this.cartDrawer.classList.remove('is-empty');
              }

              if (this.externalButton) {
                this.externalButton.classList.remove('loading');
                this.externalButton.disabled = false;
                this.externalButton.removeAttribute('aria-disabled');

                if (btnTextSpan) {
                  btnTextSpan.innerText = originalText;
                } else {
                  this.externalButton.innerText = originalText;
                }
              }

              this.syncSellableRows();
            });
        }

        handleCheckout(e) {
          if (e) e.preventDefault();

          if (this.checkoutButton && this.checkoutButton.disabled) return;

          this.handleErrorMessage();

          this.syncSellableRows();
          const queryParts = this.getSelectedItems().map((item) => `${item.id}:${item.quantity}`);

          if (queryParts.length === 0) {
            this.handleErrorMessage('Please select at least one item.');
            return;
          }

          if (this.checkoutButton) {
            this.checkoutButton.classList.add('loading');
            this.checkoutButton.disabled = true;
            const btnSpan = this.checkoutButton.querySelector('span');
            if (btnSpan) btnSpan.innerText = 'Adding...';
            else this.checkoutButton.innerText = 'Adding...';
          }

          const cartUrl = window.Shopify.routes.root + 'cart/' + queryParts.join(',');

          window.location.href = cartUrl;
        }
      },
    );
  }

  const ProductRecommendation = class extends HTMLElement {
    async connectedCallback() {
      if (!this.hasAttribute('use-automatic-recommendations')) {
        return;
      }
      console.log('Fetching product recommendations from', this.recommendationsUrl);
      const response = await fetch(
        `${this.recommendationsUrl}?product_id=${this.productId}&limit=${this.recommendationsCount}&section_id=${this.sectionId}`,
      );
      const div = document.createElement('div');
      div.innerHTML = await response.text();
      const productRecommendationsElement = div.querySelector('product-recommendation');
      if (productRecommendationsElement.hasChildNodes()) {
        this.innerHTML = productRecommendationsElement.innerHTML;
      }
    }
    get recommendationsUrl() {
      return this.getAttribute('data-product-recommendations-url');
    }
    get productId() {
      return this.getAttribute('product-id');
    }
    get sectionId() {
      return this.getAttribute('section-id');
    }
    get recommendationsCount() {
      return parseInt(this.getAttribute('recommendations-count') || 4);
    }
  };
  window.customElements.define('product-recommendation', ProductRecommendation);

  class QuotoBtn extends HTMLButtonElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        // 核心逻辑：找到弹窗并显示
        const popup = document.querySelector('.get_a_quote_popup');
        if (popup) {
          popup.classList.add('active');
        }
      });
    }
  }

  // 注册组件，继承自 button
  if (!customElements.get('quoto-btn')) {
    customElements.define('quoto-btn', QuotoBtn, { extends: 'button' });
  }

  class CustomDetails extends HTMLElement {
    constructor() {
      super();
      this.handleOutsideClick = this.handleOutsideClick.bind(this);
    }

    connectedCallback() {
      // 获取内部的 details 元素
      this.details = this.querySelector('details');
      // 监听全局点击
      document.addEventListener('click', this.handleOutsideClick);
    }

    disconnectedCallback() {
      // 卸载组件时移除监听
      document.removeEventListener('click', this.handleOutsideClick);
    }

    handleOutsideClick(event) {
      // 1. 如果 details 没打开，不需要处理
      if (!this.details.hasAttribute('open')) return;

      // 2. 检查点击的元素是否在当前组件 custom-details 内部
      // event.target 是触发点击的元素，this 是 custom-details
      const isClickInside = this.contains(event.target);
      if (!isClickInside) {
        // 3. 如果点击在外部，关闭 details
        this.details.removeAttribute('open');
      }
    }
  }

  // 注册自定义组件
  if (!customElements.get('custom-details')) {
    customElements.define('custom-details', CustomDetails);
  }
})();
